import { render, staticRenderFns } from "./DataTableFilters.vue?vue&type=template&id=0ba487fc&lang=pug&"
import script from "./DataTableFilters.vue?vue&type=script&lang=js&"
export * from "./DataTableFilters.vue?vue&type=script&lang=js&"
import style0 from "./DataTableFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DataTableFilters.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VFlex,
  VIcon,
  VLayout,
  VSelect,
  VTextField,
})
